import React, { useCallback, useRef, useState } from 'react';
import {
  FavoritesModal,
  Heading,
  Icons,
  IconSpinner,
  PrimaryButton,
  SecondaryButton,
  TalentListingCard,
} from '../../../../components';
import {
  cardRenderSizes,
  formatStringtoCamelCase,
  getFirstListingImageUrl,
  isArrayLength,
} from '../../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import {
  getUserSubscription,
  retrieveUserFavoritesList,
} from '../../../../util/userDataExtraction';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import {
  EditListingParamsType,
  EditListingTab,
  SectionHeroTabs,
  SUBSCRIPTION_TYPES,
} from '../../../../util/enums';
import { useListingPageContext } from '../../context/ListingPageContext';
import AgencyWhiteLabelBanner from './AgencyWhiteLabelBanner';
import AgencyInlineBanner from './AgencyInlineBanner';
import sliderimg1 from '../../../../assets/card-img1.png';
import sliderimg2 from '../../../../assets/card-img2.png';
import Slider from 'react-slick';
import { userSelector } from '../../../../ducks/user.duck';
import { useDispatch, useSelector } from 'react-redux';

import css from './SectionAgencyHero.module.css';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';

import RenderCampaigns from '../../SharedComponents/RenderCampaigns';
import RenderJobPost from '../../SharedComponents/RenderJobPost';
import RenderPerks from '../../SharedComponents/RenderPerks';
import RenderCouponOffer from '../../SharedComponents/RenderCouponOffer';
import { useConfiguration } from '../../../../context/configurationContext';
import { selectIsAuthenticated } from '../../../../ducks/auth.duck';
import {
  deleteItemFromFavorites,
  favoritesSelector,
} from '../../../FavoritesPage/FavoritesPage.duck';
import { associatedListingsSelector } from '../../ListingPage.duck';
import { getListingAssociatedUsers } from '../../../../util/listingDataExtraction';

const talentSliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 4,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

const SectionAgencyHero = (props, {}) => {
  const {
    publicData,
    isOwnListing,
    listingTitle,
    listing,
    showInlineBanners,
  } = useListingPageContext();

  const { isMobileLayout, intl, viewport } = props;
  const description = listing?.attributes?.description;

  const { pub_company, pub_job_title, state, city, zipCode, customLinks } = publicData || {};

  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(userSelector);
  const associatedListings = useSelector(associatedListingsSelector);
  const currentUserId = currentUser?.id?.uuid;
  const associatedUsers = getListingAssociatedUsers(listing);
  const isCurrentUserLinkedToListing = associatedUsers?.some(
    user => user?.talentId === currentUserId
  );
  const { removedItemId } = useSelector(favoritesSelector);
  const [activeFavoriteId, setActiveFavoriteId] = useState(null);

  const onRedirectPage = (page, pageParams = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration, pageParams, {}));
  };

  const [activeTab, setActiveTab] = useState(SectionHeroTabs.ABOUT);
  const sectionRefs = useRef({});

  const scrollToSection = tab => {
    const sectionRef = sectionRefs.current[tab];
    if (sectionRef) {
      sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleTabClick = tab => {
    setActiveTab(tab);
    scrollToSection(tab);
  };

  const renderInfo = (label, value, icon = null) => (
    <p>
      <span>
        <Icons name={icon || formatStringtoCamelCase(label)} /> {label ? `${label}: ` : ''}
      </span>
      <span>{value || 'N/A'}</span>
    </p>
  );

  const agencyPlusMaybe = Boolean(
    getUserSubscription(listing.author) === SUBSCRIPTION_TYPES.AGENCY_PLUS
  );

  const profileImageURL = getFirstListingImageUrl(listing);

  const sharedProps = {
    isMobileLayout,
    intl,
    viewport,
    profileImageIcon: profileImageURL,
    isCurrentUserLinkedToListing,
  };

  const componentsToRender = [RenderCouponOffer, RenderCampaigns, RenderPerks];
  const listingId = listing?.id?.uuid;
  const favorites = retrieveUserFavoritesList(currentUser) || [];
  const openFavoritesModal = id => setActiveFavoriteId(id);
  const favoritesList = favorites || [];
  const isAlreadyAddedToFavoriteslist =
    isArrayLength(favoritesList) &&
    favoritesList.some(category => category.ids?.includes(listingId));
  const firstImage = isArrayLength(listing?.images) ? listing.images[0] : null;
  const handleFavoritesList = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();

      try {
        if (isOwnListing) {
          history.push(createResourceLocatorString('FavoritesPage', routeConfiguration, {}));
          return;
        }

        if (isAlreadyAddedToFavoriteslist) {
          await dispatch(
            deleteItemFromFavorites({
              isAuthenticated,
              id: listingId,
              favorites,
              config,
              userId: currentUserId,
            })
          );
        } else {
          openFavoritesModal(listingId);
        }
      } catch (error) {
        console.error('Error while updating favorites:', error);
      }
    },
    [
      isOwnListing,
      isAlreadyAddedToFavoriteslist,
      history,
      routeConfiguration,
      dispatch,
      listingId,
      favorites,
      config,
      currentUserId,
      openFavoritesModal,
    ]
  );

  const contactActions = [
    {
      key: 'favorite',
      icon: 'star',
      labelId: 'SectionHero.favorite',
      onClick: handleFavoritesList,
      className: isAlreadyAddedToFavoriteslist ? css.favorited : undefined,
      ariaLabel: isAlreadyAddedToFavoriteslist ? 'Remove from favorites' : 'Add to favorites',
      showSpinner: removedItemId === listingId,
    },
    { icon: 'addUser', label: 'Follow' },
    { icon: 'share', label: 'Share' },
  ];
  return (
    <div className={css.heroWrapper}>
      <div className={css.heroContainer}>
        <div className={css.heroBg}>
          <div className={css.contentWidth}>
            {showInlineBanners && isMobileLayout ? (
              <AgencyWhiteLabelBanner listing={listing} />
            ) : null}
            <div className={css.heroContent}>
              <div className={css.heroContentHead}>
                <div className={css.heroContentHeadLeft}>
                  {isArrayLength(listing?.images) &&
                    listing?.images.slice(0, 1)?.map((img, index) => {
                      const imgUrl = img?.attributes?.variants['square-small2x']?.url;
                      return (
                        <div className={css.schoolImg} key={index}>
                          <img
                            src={imgUrl}
                            alt={`Featured ${index + 1}`}
                            className={css.featuredImage}
                          />
                        </div>
                      );
                    })}
                  <Heading as="h1" rootClassName={css.heading}>
                    {publicData?.organizationName}
                  </Heading>
                  <div className={css.verifySec}>
                    <Icons name="verify" /> <FormattedMessage id="BrandListingCard.verified" />
                    {agencyPlusMaybe
                      ? SUBSCRIPTION_TYPES.AGENCY_PLUS
                      : SUBSCRIPTION_TYPES.AGENCY_STANDARD}
                  </div>
                </div>
                <div className={css.heroContentHeadRight}>
                  <div className={css.bookSessionSec}>
                    <div className={css.contactSec}>
                      {contactActions.map(
                        ({
                          key,
                          icon,
                          label,
                          labelId,
                          onClick,
                          className,
                          ariaLabel,
                          showSpinner,
                        }) => (
                          <button
                            key={key || icon}
                            type="button"
                            className={className}
                            onClick={onClick}
                            aria-label={ariaLabel || label}
                          >
                            {showSpinner ? <IconSpinner /> : <Icons name={icon} />}
                            {labelId ? <FormattedMessage id={labelId} /> : label}
                          </button>
                        )
                      )}
                    </div>
                  </div>
                  <div className={css.schoolInfo}>
                    <div className={css.address}>
                      {renderInfo('City', city, 'location')}
                      {renderInfo('State', state, 'location')}
                      {renderInfo('Zip Code', zipCode, 'location')}
                    </div>
                  </div>
                  {isArrayLength(customLinks) && (
                    <div className={css.keywordSec}>
                      <h2>
                        <FormattedMessage id="SectionHero.customLinks" />
                      </h2>
                      <div className={css.keywords}>
                        {customLinks.map((link, index) => (
                          <span key={index}>
                            <strong>
                              <a href={link?.url} target="_blank" rel="noopener noreferrer">
                                {link?.name}
                              </a>
                            </strong>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={css.heroContentImg}>
              {showInlineBanners && !isMobileLayout ? (
                <AgencyWhiteLabelBanner listing={listing} />
              ) : null}
              {showInlineBanners && isOwnListing ? (
                <AgencyInlineBanner intl={intl} onRedirectPage={onRedirectPage} />
              ) : null}
              <div className={css.contentHeroTabs}>
                <div className={css.tabs}>
                  {['Home'].map((tab, index) => (
                    <span
                      key={index}
                      className={tab === activeTab ? css.active : ''}
                      onClick={() => handleTabClick(tab)}
                    >
                      {tab}
                    </span>
                  ))}
                </div>

                {isOwnListing && (
                  <div className={css.editSec}>
                    <SecondaryButton
                      type="button"
                      onClick={() =>
                        onRedirectPage('EditListingPage', {
                          ...params,
                          type: EditListingParamsType.EDIT,
                          tab: EditListingTab.DETAILS,
                        })
                      }
                    >
                      <Icons name="pen" /> <FormattedMessage id="SectionHero.edit" />
                    </SecondaryButton>
                  </div>
                )}
              </div>
              <div className={css.howItWorks}>
                <div className={css.descriptionContainer}>{description}</div>
              </div>
              <RenderJobPost
                isMobileLayout={isMobileLayout}
                intl={intl}
                viewport={viewport}
                profileImageIcon={profileImageURL}
                isCurrentUserLinkedToListing={isCurrentUserLinkedToListing}
              />
              {isArrayLength(associatedListings) && isOwnListing && (
                <div className={css.topCollectionsWrapper}>
                  <div className={css.sectionHead}>
                    <div className={css.leftSec}>
                      <h2>
                        <FormattedMessage id="SectionAgencyHero.exploreTalents" />
                      </h2>
                    </div>
                  </div>
                  <Slider {...talentSliderSettings}>
                    {associatedListings.map(listing => (
                      <TalentListingCard
                        className={css.listingCard}
                        key={listing.id.uuid}
                        listing={listing}
                        renderSizes={cardRenderSizes(false)}
                        isSectionAgencyHero
                        hideFavorite
                      />
                    ))}
                  </Slider>
                </div>
              )}
              {componentsToRender.map((Component, index) => (
                <Component key={index} {...sharedProps} />
              ))}
              <FavoritesModal
                isOpen={!!activeFavoriteId}
                onClose={() => setActiveFavoriteId(null)}
                firstImage={firstImage}
                currentUserId={currentUserId}
                activeFavoriteId={activeFavoriteId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionAgencyHero;
